import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';
import {
  buttonBarRecipe,
  buttonBarSlotRecipe,
  draggablePanelSlotRecipe,
  durationInputRecipe,
  gpsCoordinatesFieldRecipe,
} from '@theme/component';
import { breakpoints } from '@theme/foundations/breakpoints';

import { spacingVariables, spacingVariables4k } from './foundations/spacing';
import { textStyles } from './foundations/textStyles';
import { semanticTokens, tokens } from './foundations/tokens';
import { fonts, fontSizes, fontVariables, fontVariables4k } from './foundations/typography';
import {
  checkboxSlotRecipe,
  checkmarkRecipe,
  comboboxSlotRecipe,
  fieldsetSlotRecipe,
  fieldSlotRecipe,
  listboxSlotRecipe,
  menuSlotRecipe,
  numberInputSlotRecipe,
  popoverSlotRecipe,
  radioSlotRecipe,
  scrollAreaRecipe,
  selectSlotRecipe,
  separatorRecipe,
  sliderSlotRecipe,
  switchSlotRecipe,
  tableSlotRecipe,
  tabsSlotRecipe,
  tagSlotRecipe,
  textareaRecipe,
  tooltipSlotRecipe,
} from './recipes';
import { buttonRecipe } from './recipes/button.recipe';
import { inputGroupRecipe, inputRecipe } from './recipes/input.recipe';

const themeConfig = defineConfig({
  theme: {
    tokens,
    semanticTokens,
    breakpoints,
    recipes: {
      button: buttonRecipe,
      buttonBar: buttonBarRecipe,
      checkmark: checkmarkRecipe,
      durationInput: durationInputRecipe,
      input: inputRecipe,
      inputGroup: inputGroupRecipe,
      separator: separatorRecipe,
      textarea: textareaRecipe,
    },
    slotRecipes: {
      buttonBar: buttonBarSlotRecipe,
      checkbox: checkboxSlotRecipe,
      combobox: comboboxSlotRecipe,
      draggablePanel: draggablePanelSlotRecipe,
      field: fieldSlotRecipe,
      fieldset: fieldsetSlotRecipe,
      gpsCoordinates: gpsCoordinatesFieldRecipe,
      listbox: listboxSlotRecipe,
      menu: menuSlotRecipe,
      numberInput: numberInputSlotRecipe,
      popover: popoverSlotRecipe,
      radioGroup: radioSlotRecipe,
      scrollArea: scrollAreaRecipe,
      select: selectSlotRecipe,
      slider: sliderSlotRecipe,
      switch: switchSlotRecipe,
      table: tableSlotRecipe,
      tabs: tabsSlotRecipe,
      tooltip: tooltipSlotRecipe,
      tag: tagSlotRecipe,
    },
    textStyles,
  },
  globalCss: {
    'html, body': {
      ...fontVariables,
      ...spacingVariables,
      [`@media (min-width: ${breakpoints['4k']})`]: {
        ...fontVariables4k,
        ...spacingVariables4k,
      },
      fontFamily: fonts.roboto.value,
      fontSize: fontSizes.sm.value,
      fontWeight: 'regular',
      lineHeight: 1.25,
      color: 'neutral.white',
    },
    ':root': {
      '--chakra-cursor-disabled': 'default !important',
    },
    '.recharts-wrapper *:focus-visible': {
      outline: 'none !important',
    },
    '.recharts-wrapper *:focus': {
      outline: 'none !important',
    },
    // Delay autofill style that comes from browser
    'input:-webkit-autofill': {
      transition: 'background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s',
      WebkitTextFillColor: 'inherit',
    },
    'input[type=number]': {
      '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
        appearance: 'none',
        margin: 0,
      },
    },
  },
});

export const system = createSystem(defaultConfig, themeConfig);
